import * as currencyLibrary from 'currency-library';
import { Container, Card, CardHeader, Nav, NavItem, NavLink, CardBody, TabContent, TabPane, Row, Button, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import classnames from "classnames";
import React, { useEffect, useState } from 'react';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import ViewSubscription from "./ViewSubscription";
import ViewReservation from "./ViewReservation";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomer } from "../../slices/customer/fetchcustomer/thunk";
import { fetchCustomerSummary } from "../../slices/customer/simulate/thunk";
import { CustomerProfile } from "./CustomerProfile";
import { customerIdData, subscriptionListData, subscriptionsaArrayData } from "./constants/constantFunctionsView";
import { formatDate } from "./constants/DateFormat";
import { tabChangeCustomerView } from "../Utils/SetDefaultRowData";
import { initialFormValues } from "./constants/constantValues";
import { noCurrencyArrayDataFormat, currencyDataFormat } from "./constants/constantFunctions";
import { Loader } from "../Utils/Loader";
import Invoice from "./Invoice"
import Bills from "./Bills"
import { fetchBillsForCustomer } from "../../slices/customer/getbills/thunk";
import { fetchAllInvoicesForCustomer } from "../../slices/invoices/invoiceforcustomer/thunk";
import { PAGE_TITLES } from "../Common/constants";
import { AttributeTableInView } from "./AttributeTableInView";
import { fetchAllOffers } from "../../slices/offer/thunk";
import { ViewTasks } from "./ViewTasks";
import { DetailedTaskView } from "./DetailedTaskView";
import CommonButton from "../Utils/CommonButton";
import { getAllResources } from "../../slices/resources/thunk";
import { LiveSession } from "./LiveSession";
import ReactApexChart from "react-apexcharts";
import { fetchConsumedBalanceByCustomer } from "../../slices/customer/ConsumedBalance/thunk";
import { AverageConsumedBalance } from '../../slices/customer/averageCost/thunk';
import Profile from './Profile';
import UploadDocumentTable from './UploadDocumentsTable';
import { fetchCustomerEvents } from '../../slices/customer/events/thunk';
import { hasPermission } from '../Utils/UtilityFunctions';
import { fetchAllCurrencyCodes } from '../../slices/OperatorManagement/GetCurrencyCodes/thunk';
import PaymentHistoryTable from './PaymentHistory';
import ChargingHistory from './ChargingHistory';
import UsageEventsTable from './UsageEventsTable';

export default function CustomerView() {
    const [renderSimulate, setRenderSimulate] = useState(false)
    const isSimulateView = location.pathname.includes('simulate')
    const [activeTab, setActiveTab] = useState(isSimulateView ? "9" : "1");
    const [loading, setLoading] = useState(false)
    const [offer, setOffer] = useState([]);
    const [view, setView] = useState(false)
    const [taskDetails, setTaskDetails] = useState()
    const [showForm, setShowForm] = useState(isSimulateView ? true : false);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [showJSON, setShowJSON] = useState("false")
    const [buttonInitiateSession, setButtonInitiateSession] = useState(true)

    // Add dropdown state and session action
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [sessionAction, setSessionAction] = useState('initiate');
    // Toggle function for dropdown
    const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

    // Handler functions for each action
    const handleSessionAction = (action) => {
        setSessionAction(action);
        if (action === 'initiate') {
            setShowForm(true);
        }
        // Add your specific logic for update and terminate here
        setDropdownOpen(false);
    };

    let initialValues = {
        subscriptionId: '',
        usageEventType: '',
        sessionId: '',
        sessionTime: null,
        requestedUnits: '',
        uom: ''
    }
    const [submitSimulate, setSubmitSimulate] = useState();
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    //const billPermission = permissions.find((resource) => resource.resourceName === 'bill');
    //const invoicePermission = permissions.find((resource) => resource.resourceName === 'invoice');
    const customerPermission = hasPermission(permissionsMap, "customer", "customer")
    const subscriptionPermission = hasPermission(permissionsMap, "customer", "subscription")
    const taskPermission = hasPermission(permissionsMap, "customer", "task",)
    const operatorConfiguration = useSelector((state) => state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration)
    const billingenabled = operatorConfiguration?.configurations?.BillingManagement?.value?.BillingEnabled?.value === true ? true : false

    let simulateOrPreview = ""
    let noCurrencyArray = []
    let currencyArray = []

    const dispatch = useDispatch()

    const customerId = customerIdData()

    useEffect(() => {
        simulateOrPreview = "View"
        dispatch(fetchAllCurrencyCodes(setLoading));
        customerPermission && dispatch(fetchCustomer(setLoading, customerId, initialFormValues, customerPermission))
        customerPermission && dispatch(fetchCustomerSummary(customerId, setLoading, simulateOrPreview))
        billingenabled && dispatch(fetchBillsForCustomer(customerId, setLoading))
        billingenabled && dispatch(fetchAllInvoicesForCustomer(setLoading, customerId))
    }, [])

    const customerData = useSelector((state) => state.FetchCustomer.fetchCustomer)
    const fetchCustomerSummaryData = useSelector(state => state.Simulate.simulate)
    const billData = useSelector((state) => state.GetBillsForCustomer.getBills)
    const invoiceData = useSelector((state) => state.InvoiceListForCustomer.invoiceListForCustomer)
    let attributeData = customerData?.customerInfo?.attributeList || [];
    const reservationPermission = hasPermission(permissionsMap, "reservation", "reservation")
    const DocumentPermission = hasPermission(permissionsMap, "miscellaneous", "document")

    noCurrencyArray = noCurrencyArrayDataFormat(fetchCustomerSummaryData, noCurrencyArray)
    currencyArray = currencyDataFormat(fetchCustomerSummaryData, currencyArray)

    let subscriptionList = []
    subscriptionList = subscriptionListData(customerData, subscriptionList)
    let subscriptionsArray = []
    subscriptionsArray = subscriptionsaArrayData(subscriptionsArray, subscriptionList)

    useEffect(() => {
        setOffer(subscriptionsArray)
    }, [subscriptionList])

    useEffect(() => {
        dispatch(fetchConsumedBalanceByCustomer(setLoading, customerId));
         dispatch(fetchCustomerEvents(customerId))
    }, [customerId])

    const eventData = useSelector((state) => state?.CustomerEvent?.customerEvents)

    const ConsumedBalanceByCustomer = useSelector((state) => state?.fetchConsumedBalanceByCustomer?.ConsumedBalanceByCustomer)
    const operatorId = localStorage.getItem('operatorId');

    // const isEIPEnabled = operatorConfiguration?.configurations
    //     ?.find(config => config.name === "EIP")
    //     ?.value?.find(item => item.key === "Enabled")
    //     ?.value?.[0] === "True";

    const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;

    const roleName = localStorage.getItem('roleName')
    const isEVOperator = roleName === 'operatorAdmin' || roleName === "evAdmin";

    const currencyConfig = operatorConfiguration?.configurations?.DefaultCurrency?.value?.CurrencyCode?.value
    const allCurrencies = currencyLibrary.getAll();
    const DefaultCurrency = allCurrencies?.find(curr => curr.isoCode === currencyConfig) || allCurrencies?.find(curr => curr.isoCode === "USD")
    const usageConfig = operatorConfiguration?.configurations?.UsageEventsPersistanceMode?.value?.Mode?.value
    const isNativeDB = (usageConfig === "Database")

    useEffect(() => {
        if (isNativeDB) {
            dispatch(AverageConsumedBalance(setLoading, customerId))
        }
    }, [customerId])

    const averageBalance = useSelector((state) => state?.AverageConsumedBalance?.AverageConsumedBalance)
    const customerListTitle = isEIPEnabled
        ? PAGE_TITLES.CUSTOMER_LIST_EIP
        : PAGE_TITLES.CUSTOMER_LIST;

    const viewCustomerTitle = isEIPEnabled
        ? PAGE_TITLES.VIEW_CUSTOMER_EIP
        : PAGE_TITLES.VIEW_CUSTOMER;

    const series = [75];
    const deviceStatus = true; // replace with actual status check

    const options = {
        chart: {
            height: 350,
            type: 'radialBar',
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            radialBar: {
                startAngle: -135,
                endAngle: 225,
                hollow: {
                    margin: 0,
                    size: '70%',
                    position: 'front',
                },
                track: {
                    strokeWidth: '67%',
                    margin: 0,
                },
                dataLabels: {
                    show: true,
                    name: {
                        offsetY: -10,
                        show: true,
                        color: '#888',
                        fontSize: '17px',
                        formatter: function () {
                            return deviceStatus ? 'Online' : 'Offline';
                        }
                    },
                    value: {
                        formatter: function (val) {
                            return val + '%';
                        },
                        color: '#111',
                        fontSize: '36px',
                        show: true,
                    }
                }
            }
        },
        fill: {
            type: 'solid',
            colors: [deviceStatus ? '#51d28c' : '#FF0000']
        },
        stroke: {
            lineCap: 'round'
        },
        labels: ['Device Uptime %'],
    };

    const lineseries = [
        {
            name: 'This Device',
            data: [20, 49, 30, 32]
        },
        {
            name: 'Average Power Consumption ( All Devices )',
            data: [30, 42, 37, 29]
        }
    ];

    const lineoptions = {
        chart: {
            type: 'line',
            height: 350,
            toolbar: { show: false },
            zoom: {
                enabled: true
            }
        },
        colors: ['#008FFB', '#FEB019'],
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        },
        xaxis: {
            categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
        },
        yaxis: {
            title: {
                text: 'Power Consumption (kWh)'
            }
        },
        tooltip: {
            shared: true,
            y: {
                formatter: function (val) {
                    return val + ' kWh';
                }
            }
        }
    };

    const getActionDisplayText = () => {
        switch (sessionAction) {
            case 'initiate': return 'Initiate Session';
            case 'update': return 'Update Session';
            case 'terminate': return 'Terminate Session';
            default: return 'Initiate Session';
        }
    };

    return (
        <div id="csms" className="page-content bg-white pb-1 mb-0">
            <Container fluid>
                <BreadCrumb title={!isSimulateView ? viewCustomerTitle : 'Simulate'} pageTitle={customerListTitle} />
                {(isEIPEnabled) && (
                    <Row>
                        <Col lg={12}>
                            <Row className="gy-4 mb-4">
                                <Col xxl={4} md={6}>
                                    <Card className="border rounded-1 px-1 py-1 my-0 bg-white h-100">
                                        <CardHeader>Device Health Status</CardHeader>
                                        <CardBody>
                                            <ReactApexChart
                                                dir="ltr"
                                                className="apex-charts"
                                                options={options}
                                                series={series}
                                                type="radialBar"
                                                height={350}
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col xxl={4} md={6}>
                                    <Card className="border rounded-1 px-1 py-1 my-0 bg-white h-100">
                                        <CardHeader>Monthly Power Consumption</CardHeader>
                                        <CardBody>
                                            <ReactApexChart
                                                dir="ltr"
                                                className="apex-charts"
                                                options={lineoptions}
                                                series={lineseries}
                                                type="line"
                                                height={350}
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col xxl={4} md={6}>
                                    <Card className="border rounded-1 px-1 py-1 my-0 bg-white h-100">
                                        <CardHeader>Device Energy Cost</CardHeader>
                                        <CardBody>
                                            <h2 className="text-muted text-uppercase fs-13 mt-4">
                                                MONTH TILL DATE  (IN {DefaultCurrency?.symbol})
                                            </h2>
                                            <h2 className="mt-4 ff-secondary fw-semibold fs-1 align-items-center justify-content-center d-flex mb-4">
                                                <span className="mt-4" style={{ fontSize: "70px" }}>
                                                    {DefaultCurrency?.symbol}{Math.abs(ConsumedBalanceByCustomer?.[0]?.consumedbalance)}
                                                </span>
                                            </h2>
                                            <div className="col-md-12 mt-4 d-flex flex-column align-items-center justify-content-center text-center mt-5">
                                                <h5 className="text-muted text-uppercase fs-13 mb-0 ms-3">
                                                    AVERAGE COST/Hr
                                                </h5>
                                                <div className="d-flex align-items-center mt-0 ms-2">
                                                    <div className="flex-shrink-0">
                                                        <i className="display-6 text-muted ri-exchange-dollar-line"></i>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h2 className="mb-0">
                                                            <span className="counter-value">
                                                                {isNativeDB ? (
                                                                    <>
                                                                        {DefaultCurrency?.symbol} {averageBalance?.AverageConsumedBalance}
                                                                    </>
                                                                ) : (
                                                                    <>&nbsp;&nbsp;&nbsp;&nbsp;-</>
                                                                )}
                                                            </span>
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                )}
                <div>
                    <div className=" px-4 py-3 my-2 bg-white h-100">
                        {isSimulateView ? null :
                            <CardHeader >
                                <div className="d-flex align-items-center justify-content-between">
                                    <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
                                        {!isSimulateView ? <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "1" })}
                                                onClick={() => {
                                                    tabChangeCustomerView("1", activeTab, setActiveTab, setShowJSON);
                                                }}
                                            >
                                                <i className="fas fa-home"></i>
                                                Profile
                                            </NavLink>
                                        </NavItem> : null}

                                        {!isSimulateView && DocumentPermission ? <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "2" })}
                                                onClick={() => {
                                                    tabChangeCustomerView("2", activeTab, setActiveTab, setShowJSON);
                                                }}
                                            >
                                                <i className="fas fa-file-alt"></i>
                                                Document
                                            </NavLink>
                                        </NavItem> : null}

                                        {reservationPermission && reservationPermission?.has("view") && (
                                            <NavItem>
                                                <NavLink
                                                    to="#"
                                                    className={classnames({ active: activeTab === "3" })}
                                                    onClick={() => {
                                                        tabChangeCustomerView("3", activeTab, setActiveTab, setShowJSON);
                                                    }}
                                                    type="button"
                                                >
                                                    <i className="far fa-user"></i>
                                                    Reservations
                                                </NavLink>
                                            </NavItem>
                                        )}
                                        {subscriptionPermission && subscriptionPermission?.has("view") && !isSimulateView && (
                                            <NavItem>
                                                <NavLink
                                                    to="#"
                                                    className={classnames({ active: activeTab === (reservationPermission ? "4" : "3") })}
                                                    onClick={() => {
                                                        tabChangeCustomerView(reservationPermission ? "4" : "3", activeTab, setActiveTab, setShowJSON);
                                                    }}
                                                    type="button"
                                                >
                                                    <i className="far fa-envelope"></i>
                                                    Subscriptions
                                                </NavLink>
                                            </NavItem>
                                        )}
                                        {!isSimulateView ?
                                            <NavItem>
                                                <NavLink
                                                    to="#"
                                                    type="button"
                                                    className={classnames({
                                                        active: activeTab === (reservationPermission ? "5" : subscriptionPermission ? "4" : "3"),
                                                    })}
                                                    onClick={() => {
                                                        tabChangeCustomerView(reservationPermission ? "5" : subscriptionPermission ? "4" : "3", activeTab, setActiveTab, setShowJSON);
                                                    }}
                                                >
                                                    Attributes
                                                </NavLink>
                                            </NavItem> : null}
                                        {taskPermission && taskPermission?.has("view") && !isSimulateView && (
                                            <NavItem>
                                                <NavLink
                                                    to="#"
                                                    type="button"
                                                    className={classnames({
                                                        active: activeTab === (reservationPermission ? "6" : subscriptionPermission ? "5" : taskPermission ? "4" : "3"),
                                                    })}
                                                    onClick={() => {
                                                        tabChangeCustomerView(reservationPermission ? "6" : subscriptionPermission ? "5" : taskPermission ? "4" : "3", activeTab, setActiveTab, setShowJSON);
                                                    }}
                                                >
                                                    Activity Logs
                                                </NavLink>
                                            </NavItem>
                                        )}
                                        {billingenabled && !isSimulateView && (
                                            <>
                                                <NavItem>
                                                    <NavLink
                                                        to="#"
                                                        className={classnames({ active: activeTab === ("7") })}
                                                        onClick={() => {
                                                            tabChangeCustomerView("7", activeTab, setActiveTab, setShowJSON);
                                                        }}
                                                        type="button"
                                                    >
                                                        <i className="far fa-envelope"></i>
                                                        Invoices
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        to="#"
                                                        className={classnames({ active: activeTab === ("8") })}
                                                        onClick={() => {
                                                            tabChangeCustomerView("8", activeTab, setActiveTab, setShowJSON);
                                                        }}
                                                        type="button"
                                                    >
                                                        <i className="far fa-envelope"></i>
                                                        Bills
                                                    </NavLink>
                                                </NavItem>
                                            </>
                                        )}
                                        {!isSimulateView && !isEVOperator ?
                                            <NavItem className="d-flex align-items-center justify-content-end">
                                                <NavLink
                                                    className={classnames("d-flex align-items-center", {
                                                        active: activeTab === "9",
                                                    })}
                                                    onClick={() => {
                                                        tabChangeCustomerView("9", activeTab, setActiveTab, setShowJSON);
                                                    }}
                                                >
                                                    <i className="fas fa-video me-2"></i>
                                                    <span>{!isSimulateView ? 'Active Sessions' : 'Simulate'}</span>
                                                </NavLink>
                                            </NavItem> : null}
                                            {(!isSimulateView && !isEVOperator) ?
                                            <NavItem className="d-flex align-items-center justify-content-end">
                                                <NavLink
                                                    className={classnames("d-flex align-items-center", {
                                                        active: activeTab === "10",
                                                    })}
                                                    onClick={() => {
                                                        tabChangeCustomerView("10", activeTab, setActiveTab, setShowJSON);
                                                    }}
                                                >
                                                    <i className="fas fa-video me-2"></i>
                                                    <span>Usage Events</span>
                                                </NavLink>
                                            </NavItem> : null}
                                        {!isSimulateView && isEVOperator ? 
                                        ( 
                                            <>
                                            <NavItem className="d-flex align-items-center justify-content-end">
                                                <NavLink
                                                    className={classnames("d-flex align-items-center", {
                                                        active: activeTab === "10",
                                                    })}
                                                    onClick={() => {
                                                        tabChangeCustomerView("10", activeTab, setActiveTab, setShowJSON);
                                                    }}
                                                >
                                                    <i className="fas fa-video me-2"></i>
                                                    <span>Charging History</span>
                                                </NavLink>
                                            </NavItem> 
                                             <NavItem className=" ">
                                                <NavLink
                                                    className={classnames("d-flex align-items-center", {
                                                        active: activeTab === "11",
                                                    })}
                                                    onClick={() => {
                                                        tabChangeCustomerView("11", activeTab, setActiveTab, setShowJSON);
                                                    }}
                                                >
                                                    <span>Payment History</span>
                                                </NavLink>
                                            </NavItem></> ) : null}
                                    </Nav>
                                    {/* Updated dropdown section */}
                                    {activeTab === "9" && !isSimulateView && (
                                        <div className="d-flex align-items-center">
                                            {/* {!showForm && (
                                                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                                    <DropdownToggle
                                                        caret
                                                        className="d-flex bg-primary text-white rounded-1 px-4 py-2 align-items-center"
                                                    >
                                                        {getActionDisplayText()}
                                                    </DropdownToggle>
                                                    <DropdownMenu>
                                                        {sessionAction !== 'initiate' && (
                                                            <DropdownItem
                                                                className="text-primary border-bottom"
                                                                onClick={() => handleSessionAction('initiate')}
                                                            >
                                                                Initiate
                                                            </DropdownItem>
                                                        )}
                                                        {sessionAction !== 'update' && (
                                                            <DropdownItem
                                                                className="text-primary border-bottom"
                                                                onClick={() => handleSessionAction('update')}
                                                            >
                                                                Update
                                                            </DropdownItem>
                                                        )}
                                                        {sessionAction !== 'terminate' && (
                                                            <DropdownItem
                                                                className="text-primary"
                                                                onClick={() => handleSessionAction('terminate')}
                                                            >
                                                                Terminate
                                                            </DropdownItem>
                                                        )}
                                                    </DropdownMenu>
                                                </Dropdown>
                                            )} */}
                                            <i
                                                className="ri-refresh-line p-2 fw-bolder ms-2"
                                                style={{ fontSize: '24px', cursor: 'pointer' }}
                                                onClick={() => setIsRefreshing(true)}
                                                title="Refresh"
                                            ></i>
                                        </div>
                                    )}
                                    {activeTab === (reservationPermission ? "4" : "3")  && (
                                        <div className="d-flex align-items-center">
                                            <i
                                                className="ri-refresh-line p-2 fw-bolder ms-2"
                                                style={{ fontSize: '24px', cursor: 'pointer' }}
                                                onClick={() => setIsRefreshing(true)}
                                                title="Refresh"
                                            ></i>
                                        </div>
                                    )}
                                   
                                           

                                </div>
                            </CardHeader>}
                        <CardBody>
                            <TabContent activeTab={activeTab}>
                                {!isSimulateView ?
                                    <TabPane tabId="1" >
                                        <Profile
                                            customerPermission={customerPermission}
                                            customerData={customerData}
                                            noCurrencyArray={noCurrencyArray}
                                            currencyArray={currencyArray}
                                            fetchCustomerSummaryData={fetchCustomerSummaryData}
                                            formatDate={formatDate}
                                        />
                                    </TabPane> : null}

                                {!isSimulateView ?
                                    <TabPane tabId="2" >
                                        <UploadDocumentTable />
                                    </TabPane> : null}

                                {reservationPermission && !isSimulateView && <TabPane tabId="3">
                                    <ViewReservation />
                                </TabPane>}
                                {subscriptionPermission && (
                                    <TabPane tabId={reservationPermission ? "4" : "3"}>
                                        {/* ✨ White card wrapper */}
                                        <div className=" px-4 py-3 my-2 bg-white h-100">
                                            <CustomerProfile
                                                customerPermission={customerPermission}
                                                customerData={customerData}
                                                noCurrencyArray={noCurrencyArray}
                                                currencyArray={currencyArray}
                                                fetchCustomerSummaryData={fetchCustomerSummaryData}
                                                formatDate={formatDate}
                                                isRefreshing={isRefreshing}
                                            />

                                            <ViewSubscription
                                                offer={offer}
                                                customerData={customerData}
                                                subscriptionPermission={subscriptionPermission}
                                            />
                                        </div>
                                    </TabPane>
                                )}
                                <TabPane tabId={reservationPermission ? "5" : subscriptionPermission ? "4" : "3"}>
                                    <AttributeTableInView attributeData={attributeData} />
                                </TabPane>
                                {taskPermission && <TabPane tabId={reservationPermission ? "6" : subscriptionPermission ? "5" : taskPermission ? "4" : "3"}>
                                    {!view ? <ViewTasks view={view} setTaskDetails={setTaskDetails} setView={setView} /> : <DetailedTaskView taskDetails={taskDetails} />}
                                    {(view) && <Row lg={6} className=" mt-4  mb-4">
                                        <div className='ms-n0'>
                                            <CommonButton
                                                outline={true}
                                                className={
                                                    "btn-label rv-secondary-btn rounded-1 px-2 ps-3 py-1  w-md-auto text-nowrap"
                                                }
                                                color={"main-color"}
                                                type={"reset"}
                                                buttonAction={() => {
                                                    if (view) {
                                                        setView(false)
                                                    }
                                                }}
                                                buttonText={"Back"}
                                                icon={
                                                    <i
                                                        className="ri-play-mini-fill label-icon align-middle fs-16 me-1"
                                                        style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}
                                                    ></i>
                                                }
                                                btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                            />
                                        </div>
                                    </Row>}
                                </TabPane>}
                                {billingenabled && <><TabPane tabId={"7"}>
                                    <Invoice invoiceData={invoiceData} />
                                </TabPane><TabPane tabId={"8"}>
                                        <Bills billData={billData} />
                                    </TabPane></>}
                                    
                                <TabPane tabId="9">
                                    <LiveSession
                                        customerId={customerId}
                                        showForm={showForm}
                                        setShowForm={setShowForm}
                                        setButtonInitiateSession={setButtonInitiateSession}
                                        isSimulateView={isSimulateView}
                                        isRefreshing={isRefreshing}
                                        setIsRefreshing={setIsRefreshing}
                                        sessionAction={sessionAction} // Pass the session action
                                        setSessionAction={setSessionAction}
                                    />
                                </TabPane>
                                <TabPane tabId="10">
                                    {isEVOperator ? <ChargingHistory/> : <UsageEventsTable eventData={eventData} showJSON={showJSON} setShowJSON={setShowJSON}/>}
                                </TabPane>
                                <TabPane tabId="11">
                                    <PaymentHistoryTable />
                                </TabPane>
                            </TabContent>
                        </CardBody>
                    </div>
                </div>
            </Container>
            {loading && (<Loader />)}
        </div>
    )
}